import React from 'react'
import { getHotelBookingPriceBreakdown } from '../../utils/hotelBookingPricing'

const fmt = (n, currency, formatCurrency) => formatCurrency(n, currency)

/**
 * Price breakdown for hotel bookings (card detail + summaries).
 * Hotel tax and Stripe processing fees are combined as a single "Tax & fees" line.
 * @param {'detailed'|'compact'} variant - detailed uses card styling; compact uses summary styling
 */
const HotelBookingPriceBreakdown = ({
  booking,
  formatCurrency,
  variant = 'detailed',
  className = ''
}) => {
  const {
    currency,
    baseAmount,
    taxAndFees,
    markupAmount,
    totalPayable
  } = getHotelBookingPriceBreakdown(booking)

  if (variant === 'compact') {
    return (
      <div className={`space-y-2 text-sm ${className}`}>
        <div className="flex justify-between text-slate-600">
          <span>Base amount</span>
          <span className="font-medium">{fmt(baseAmount, currency, formatCurrency)}</span>
        </div>
        <div className="flex justify-between text-slate-600">
          <span>Tax &amp; fees</span>
          <span className="font-medium">{fmt(taxAndFees, currency, formatCurrency)}</span>
        </div>
        {markupAmount > 0 && (
          <div className="flex justify-between text-slate-600">
            <span>Markup</span>
            <span className="font-medium">{fmt(markupAmount, currency, formatCurrency)}</span>
          </div>
        )}
        <div className="flex justify-between text-lg font-bold text-slate-900 pt-3 border-t-2 border-slate-300">
          <span>Total</span>
          <span>{fmt(totalPayable, currency, formatCurrency)}</span>
        </div>
      </div>
    )
  }

  return (
    <div className={`space-y-2 text-sm ${className}`}>
      <div className="flex justify-between text-slate-600">
        <span>Base amount</span>
        <span className="font-medium">{fmt(baseAmount, currency, formatCurrency)}</span>
      </div>
      {taxAndFees > 0 && (
        <div className="flex justify-between text-slate-600">
          <span>Tax &amp; fees</span>
          <span className="font-medium">{fmt(taxAndFees, currency, formatCurrency)}</span>
        </div>
      )}
      {markupAmount > 0 && (
        <div className="flex justify-between text-slate-600">
          <span>Markup</span>
          <span className="font-medium">{fmt(markupAmount, currency, formatCurrency)}</span>
        </div>
      )}
      <div className="flex justify-between text-slate-900 font-semibold pt-2 border-t border-slate-200">
        <span>Total payable</span>
        <span>{fmt(totalPayable, currency, formatCurrency)}</span>
      </div>
    </div>
  )
}

export default HotelBookingPriceBreakdown
